import { PersonPostionGroup } from '@aibees/elephant/feature/search-table-people';

export function getWorkHistoryDates(item: PersonPostionGroup) {
  const startDateString = item.date?.start;
  const endDateString = item.date?.end;

  const startDate = startDateString ? new Date(startDateString) : null;
  const endDate = endDateString ? new Date(endDateString) : null;

  return { startDate, endDate };
}
